<template>
  <div
    class="slide pdf fp-noscroll"
    :style="slide.backgroundColor ? `background-color: ${slide.backgroundColor};` : 'transparent;'"
  >
    <div class="bg-full" v-if="slide.photo" :style="`background-image: url(${slide.photo})`"></div>
    <!-- <iframe :src="item.file" frameborder="0" class="pdf-embed"></iframe> -->

    <iframe :src="`https://docs.google.com/gview?url=${slide.file}&embedded=true`" frameborder="0"></iframe>
    <audio :src="slide.audio" class="hidden" ref="audio"  controls="" data-autoplay loop v-if="slide.audio"></audio>

    <app-footer :footer="slide.footnote" :details="slide.details" :hasAudio="slide.audio" @mute="$refs.audio.muted = !$refs.audio.muted"></app-footer>
  </div>
</template>

<script>
import AppFooter from "./Footer";
export default {
  props: ["slide"],
  components: { AppFooter },
  methods: {
    mute() {
      
    }
  },
  mounted() {}
};
</script>

<style scoped>
.slide {
  position: relative;
}
.bg-full {
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.5;
  filter: blur(35px);
}
iframe {
  width: 40%;
  height: 100%;
  margin: 0 auto;
}
.hidden {
  visibility: hidden;
  height: 0;
  width: 0;
}
@media (max-width: 1200px) {
  iframe {
    width: 60%;
  }
}
@media (max-width: 991px) {
  iframe {
    width: 80%;
  }
}
@media (max-width: 575px) {
  iframe {
    width: 100%;
  }
}
</style>